'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var React = require('react');
var Toolbar = require('./Toolbar.js');
var HousecallProLogo = require('../../../IconsAndImages/Logos/HousecallProLogo.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var OnboardingToolbar = function OnboardingToolbar(props) {
  return React__default["default"].createElement(Toolbar, _extends["default"]({
    color: 'secondary',
    elevation: 0,
    centerChildren: props.centerChildren ? props.centerChildren : React__default["default"].createElement(HousecallProLogo, {
      width: 140
    })
  }, props));
};

module.exports = OnboardingToolbar;
